import React from 'react';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-ink" aria-labelledby="hero-title" data-id="element-76" data-mp="ejwk9bk3of7b">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/52d0ee5d-99ee-4132-8905-7a13785da3cc.jpg" alt="Dos profesionales caminando por una pasarela de vidrio en un distrito corporativo moderno" className="absolute inset-0 h-full w-full object-cover object-[72%_center] lg:object-[62%_center]" data-id="element-77" data-mp="9ka5uysjcswx" />
      <div className="absolute inset-0 bg-ink/85 sm:bg-ink/70 lg:bg-gradient-to-r lg:from-ink lg:via-ink/80 lg:to-ink/25" aria-hidden="true" data-id="element-78" data-mp="xaxghrtu5wn6" />

      <div className="relative mx-auto flex min-h-[94vh] max-w-page flex-col justify-center px-5 pb-20 pt-32 sm:px-10 sm:pb-28 sm:pt-36 lg:min-h-screen lg:px-12 lg:py-44" data-id="element-79" data-mp="ncq4lneem4s1">
        <div className="max-w-2xl" data-id="element-80" data-mp="382fedm0930dv">
          <p className="max-w-xs font-sans text-[10px] font-medium uppercase leading-relaxed tracking-widest2 text-champagne sm:max-w-none sm:text-[11px]" data-id="element-81" data-mp="381e3bhj8idw5">
            Para personas con metas, visión y ganas de crecer
          </p>

          <h1 id="hero-title" className="mt-9 font-sans text-[2.3rem] font-light uppercase leading-[1.08] text-ivory sm:text-[3.4rem] lg:text-[4.1rem]" data-id="element-82" data-mp="3o6u71a6kmrcx">
            Tal vez no necesitas
            <br data-id="element-83" data-mp="3eb8x8pv9gmsm" />
            <span className="font-serif italic normal-case text-ivory/70" data-id="element-84" data-mp="30iayquniueku">
              otra meta.
            </span>
            <span className="mt-6 block text-[0.75em] text-steel-200" data-id="element-85" data-mp="358zoo5jjz3hv">
              Necesitas una
            </span>
            <span className="mt-1 block font-serif text-[1.15em] italic normal-case leading-[1.02] text-champagne" data-id="element-86" data-mp="2ql68ojqk1yyr">
              nueva posibilidad.
            </span>
          </h1>

          <p className="mt-10 max-w-lg font-sans text-[17px] font-light leading-relaxed text-steel-200 sm:text-lg" data-id="element-87" data-mp="2hk84o1g49rg6">
            Hay oportunidades que no estabas buscando, simplemente porque aún no
            sabías que existían.
          </p>

          <p className="mt-6 max-w-lg font-sans text-base font-light leading-relaxed text-steel-200/85" data-id="element-88" data-mp="s44ifoom7nif">
            Conoce una alternativa dentro de la industria de servicios
            financieros para aprender, desarrollarte y crear nuevas
            posibilidades para tu futuro.
          </p>

          <p className="mt-5 font-sans text-sm font-light text-steel-200/70" data-id="element-89" data-mp="db2f5gbomhns">
            Sin experiencia previa. Con capacitación y acompañamiento.
          </p>

          <div className="mt-12" data-id="element-90" data-mp="16346ov87u0e2">
            <CtaButton label="Quiero conocer más" tone="champagne" targetId="oportunidad" data-id="element-91" data-mp="15zq69sj44199" />
            <p className="mt-5 font-sans text-sm font-light text-steel-200" data-id="element-92" data-mp="x1w7maxvkvix">
              Primero conoce. Después decide.
            </p>
          </div>
        </div>
      </div>
    </section>;
}